export default "__VITE_ASSET__uaQjDjz0BgptWoPcKO2NJg__"